import * as Sentry from '@sentry/browser';
import camelCase from 'camelcase';

import { formClassNames, formHooks } from './formClassNames';

/**
 * Replaces placeholders like __id__ or __wave.slug__ (see route_placeholder() in app/Helpers/Helper.php) with values from row
 *
 * @param {string} url
 * @param {object} row
 * @returns {string}
 */
export function replaceUrlParameters(url, row) {
    var regex = /__([a-zA-Z0-9.]+(?:_[a-zA-Z0-9.]+)*)__/g;

    Array.from(url.matchAll(regex)).forEach((match) => {
        const row_property = match[1];
        var row_value = '';

        if (row_property.includes('.')) {
            const [relation, property] = row_property.split('.');

            row_value =
                row[relation]?.[property] || row[camelCase(property)] || '';
        } else {
            row_value = row[row_property] || row[camelCase(row_property)] || '';
        }

        url = url.replace(match[0], row_value);
    });

    return url;
}

export function parseJson(string_to_parse) {
    if (string_to_parse.trim().length === 0) {
        return null;
    }

    try {
        var data = JSON.parse(string_to_parse);
    } catch (error) {
        console.error(error, string_to_parse);
        Sentry.captureException(error);

        return null;
    }

    return data;
}

export function initializeActivityConstants() {
    if (window['ActivityConstants']) {
        return;
    }

    const activity_constants_script = document.querySelector(
        'script[data-selector="activity-constants"]',
    );

    if (!activity_constants_script) {
        return;
    }

    const constants = parseJson(activity_constants_script.textContent);

    if (constants === null) {
        return;
    }

    window['ActivityConstants'] = constants;
}

export function isNotSupported() {
    // see https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser/9851769#9851769
    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/ !!document.documentMode;

    return isIE;
}

export function getBrandColor() {
    var user_name = document.querySelector(
        '.m-topbar .m-topbar__nav.m-nav > .m-nav__item.m-topbar__user-profile > .m-nav__link .m-topbar__username',
    );

    if (user_name) {
        return getComputedStyle(user_name).getPropertyValue('color');
    }

    return 'rgb(54, 163, 247)';
}

export function getCsrfToken() {
    if (document.querySelector('meta[name="csrf-token"]')) {
        return document.querySelector('meta[name="csrf-token"]').content;
    }

    return null;
}

export function redirectTo(url) {
    window.location.href = url;
}

export function insertAlert(alert_text, parent_element = null) {
    var alert =
        '<div class="m-alert m-alert--icon m-alert--icon-solid m-alert--outline alert alert-danger alert_div mx-3"  >\
            <div class="m-alert__icon m-alert__icon-sm p-1">\
                <i class="la la-exclamation-circle"></i>\
                <span></span>\
            </div>\
            <div class="m-alert__text py-2">__alert_text__\
            </div>\
        </div>';

    if (parent_element === null) {
        parent_element = document.createElement('div');
    }
    parent_element
        .querySelectorAll('.alert_div')
        .forEach((alert) => alert.remove());
    parent_element.insertAdjacentHTML(
        'beforeend',
        alert.replace(/__alert_text__/g, e(alert_text)),
    );

    return parent_element;
}

export function setBorderBrandColorForCheckedRadio() {
    var color = getBrandColor();

    $('.m-option').css('border', '1px solid #ebedf2');
    $('input:visible:checked')
        .not('.component-choice-property-option')
        .closest('label')
        .css('border', '1px solid ' + color);
}

export function showSuccessMessage(message, message_container = null) {
    message_container =
        message_container || document.querySelector('.m-wrapper');

    var alert = document.createElement('div');

    alert.classList.add('alert', 'alert-success');
    alert.id = 'success-alert';

    var alert_message = document.createElement('strong');
    alert_message.innerText = message;

    alert.appendChild(alert_message);

    message_container.insertAdjacentElement('afterbegin', alert);

    $(alert)
        .delay(4000)
        .slideUp(200, () => $(alert).alert('close'));
}

export function showJsonErrorInForm(form, response) {
    var message = lang.has('general.error_' + response.status)
        ? lang.get('general.error_' + response.status)
        : response.statusText;
    if (!response.responseJSON) {
        alert(message);
        return;
    }

    if (!response.responseJSON.errors) {
        alert(message);
        return;
    }

    var errors = response.responseJSON.errors;

    Object.keys(errors).forEach(function (property) {
        showErrorInFormField(errors, property, form);
    });
}

export function showErrorInFormField(errors, property, form) {
    let property_name_regex = /(.*)\.(.*)/;

    let field = form.querySelector(
        '[name="' +
            jq(property.replace(property_name_regex, '$1[$2]')) +
            '"]:not([type="hidden"])',
    );

    if (field === null || !field.checkVisibility()) {
        console.error(errors);

        let error_parent = form.querySelector('.modal-body')
            ? form.querySelector('.modal-body')
            : form;

        insertAlert(errors[property][0], error_parent);

        return;
    }

    let message = errors[property][0];

    if (field.tagName === 'INPUT' && field.type === 'radio') {
        let choice_list = field.closest('[' + formHooks.choiceList + ']');

        choice_list.classList.add(formClassNames.invalid);
        choice_list.insertAdjacentHTML(
            'afterend',
            invalidFeedbackHtml(message, property),
        );

        return;
    }

    if (field.tagName === 'INPUT' || field.tagName === 'BUTTON') {
        field.classList.add(formClassNames.invalid);
        field.setAttribute('aria-invalid', 'true');
        field.insertAdjacentHTML(
            'afterend',
            invalidFeedbackHtml(message, property),
        );

        return;
    }

    if (field.tagName === 'SELECT') {
        let select = field.closest('.bootstrap-select');

        field.setAttribute('aria-invalid', 'true');
        select.classList.add(formClassNames.invalid);
        select.insertAdjacentHTML(
            'afterend',
            invalidFeedbackHtml(message, property),
        );

        return;
    }

    if (field.tagName === 'TEXTAREA') {
        field.classList.add(formClassNames.invalid);
        field.setAttribute('aria-invalid', 'true');

        let insert_feedback_element = field.parentElement.classList.contains(
            'input-group',
        )
            ? field.parentElement
            : field;

        insert_feedback_element.insertAdjacentHTML(
            'afterend',
            invalidFeedbackHtml(message, property, true),
        );

        return;
    }
}

/**
 * The error message markup of resources/views/components/form-group/error.blade.php.
 * Without always_visible it only shows next to a field marked is-invalid.
 */
export function invalidFeedbackHtml(
    message,
    error_key,
    always_visible = false,
) {
    return (
        '<div class="' +
        formClassNames.invalidFeedback +
        (always_visible ? ' d-block' : '') +
        '" ' +
        formHooks.errorFor +
        '="' +
        e(error_key) +
        '"><strong>' +
        e(message) +
        '</strong></div>'
    );
}

export function showErrorInAlert(response, table = null) {
    console.error(response);

    var content_wrapper = document.querySelector('.m-wrapper');

    if (response.status === 404 && content_wrapper) {
        content_wrapper.insertAdjacentHTML(
            'afterbegin',
            '<div class="alert alert-danger" id="error-danger">' +
                lang.get('general.404') +
                '</div>',
        );

        content_wrapper.scrollIntoView(true);

        if ($.fn.dataTable && table instanceof $.fn.dataTable.Api) {
            table.draw();
        }

        $('#error-danger')
            .delay(5000)
            .slideUp(200, function () {
                $(this).alert('dispose');
            });

        return;
    }

    if (response.message) {
        alert(lang.get('general.error') + ': ' + response.message);
        return;
    }

    if (response.responseJSON === undefined) {
        alert(lang.get('general.error_' + response.status));
        return;
    }

    if (typeof response.responseJSON === 'string') {
        response.responseJSON = parseJson(response.responseJSON);
    }

    if (response.responseJSON.message) {
        alert(lang.get('general.error') + ': ' + response.responseJSON.message);
        return;
    }

    if (Array.isArray(response.responseJSON.errors)) {
        alert(response.responseJSON.errors[0]['message']);
        return;
    }

    if (typeof response.responseJSON.errors === 'object') {
        alert(
            Object.keys(response.responseJSON.errors)
                .map((key) => response.responseJSON.errors[key])
                .join(', '),
        );
        return;
    }

    alert(lang.get('general.error_' + response.status));
}

export function hideButtonShowLoader(parent_element) {
    if (!parent_element) {
        return;
    }

    if (parent_element instanceof NodeList) {
        parent_element.forEach((e) => hideButtonShowLoader(e));
        return;
    }

    parent_element
        .querySelectorAll('button:not(.do-not-apply-loader),a.btn')
        .forEach((button) => {
            button.classList.add('d-none');

            // if a button with a name is disabled its value is potentially not sent when submitting a form
            if (!button.name) {
                button.disabled = true;
            }
        });

    if (parent_element.querySelector('[data-form-actions-main]')) {
        parent_element = parent_element.querySelector(
            '[data-form-actions-main]',
        );
    }

    parent_element.insertAdjacentHTML(
        'afterbegin',
        '<div class="m-loader m-loader--brand"></div>',
    );
}

export function showButtonHideLoader(parent_element) {
    if (!parent_element) {
        return;
    }

    if (parent_element instanceof NodeList) {
        parent_element.forEach((e) => showButtonHideLoader(e));
        return;
    }

    parent_element
        .querySelectorAll('button:not(.do-not-apply-loader),a.btn')
        .forEach((button) => {
            button.classList.remove('d-none');
            button.disabled = false;
        });

    parent_element
        .querySelectorAll('.m-loader')
        .forEach((loader) => loader.remove());
}

export function redirectOrReload(url) {
    if (!url) {
        window.location.reload();

        return;
    }

    var current_url = window.location.href;

    if (url === current_url) {
        window.location.reload();

        return;
    }

    window.location.assign(url);

    var regex = new RegExp(/(.*)#\w*$/);

    if (!regex.test(url)) {
        return;
    }

    if (regex.exec(url)[1] === current_url) {
        window.location.reload();
    }
}

/**
 * Escape HTML
 *
 * @param {string} string
 * @returns {string}
 */
export function e(string) {
    var p = document.createElement('p');
    p.appendChild(document.createTextNode(string));
    return p.innerHTML;
}

/**
 *
 * @see https://learn.jquery.com/using-jquery-core/faq/how-do-i-select-an-element-by-an-id-that-has-characters-used-in-css-notation/
 */
export function jq(myid) {
    return myid.replace(/("|:|\.|\[|\]|,|=|@)/g, '\\$1');
}

export function getSelectedComponentContainer(
    component_containers,
    value,
    key = 'id',
) {
    if (!component_containers || !Array.isArray(component_containers)) {
        return null;
    }

    for (const container of component_containers) {
        if (String(container[key]) === String(value)) {
            return container;
        }

        if (container.children && Array.isArray(container.children)) {
            const found = getSelectedComponentContainer(
                container.children,
                value,
            );

            if (found) {
                return found;
            }
        }
    }

    return null;
}

export function undotErrorObject(errors) {
    const form_errors = {};

    if (!errors) {
        return form_errors;
    }

    Object.keys(errors).forEach((key) => {
        const keys = key.split('.');
        let current = form_errors;

        for (let i = 0; i < keys.length - 1; i++) {
            const current_key = keys[i];
            if (!current[current_key]) {
                current[current_key] = {};
            }
            current = current[current_key];
        }

        const final_key = keys[keys.length - 1];
        current[final_key] = errors[key];
    });

    return form_errors;
}

export function orderObjectByPropertyValue(object) {
    const result = {};

    Object.keys(object)
        .sort((a, b) => object[a].localeCompare(object[b]))
        .forEach((key) => {
            result[key] = object[key];
        });

    return result;
}

/**
 * Splits the string on whitespace and parses every part individually, so a scan
 * containing multiple labels (e.g. "1S10AW008QMHPC01X0Y1 1S40ay0090euzvq0pgvy")
 * is parsed to "PC01X0Y1 zvq0pgvy". Parts without a known identifier are kept
 * as-is (e.g. "1H36280ZFV 1S40AYZVW08P8S" -> "1H36280ZFV ZVW08P8S"). When no
 * part has one, the generic fallback is applied to the whole string instead.
 *
 * @see https://neg-it.myjetbrains.com/youtrack/issue/PLUTO-567
 * @see https://neg-it.myjetbrains.com/youtrack/issue/PLUTO-4600
 * @see https://neg-it.myjetbrains.com/youtrack/issue/PLUTO-4707
 * @see https://neg-it.myjetbrains.com/youtrack/issue/PLUTO-5367
 * @param {*} string
 * @returns {string}
 */
export function parseStringForSerialNumber(string) {
    const parts = string.split(/\s+/).filter((part) => part !== '');
    const serial_numbers = parts.map((part) =>
        parseIdentifierForSerialNumber(part),
    );

    if (serial_numbers.some((serial_number) => serial_number !== null)) {
        return serial_numbers
            .map((serial_number, index) => serial_number ?? parts[index])
            .join(' ');
    }

    // ── Generic fallback ────────────────────────────────────────────────
    // comma-separated strings
    for (const part of string.split(',')) {
        const trimmed_part = part.trim();

        if (/^[A-Za-z0-9]{10}$/.test(trimmed_part)) {
            return trimmed_part;
        }
    }

    return string;
}

/**
 * @param {string} string
 * @returns {string|null}
 */
function parseIdentifierForSerialNumber(string) {
    // ── HP ──────────────────────────────────────────────────────────────
    // HP uses the GS1 Application Identifier (21). https://ref.gs1.org/ai/
    const standard_gs1_match = string.match(
        /\(21\)([A-Za-z0-9]{1,20})(?=\(|\)|$)/,
    );

    if (standard_gs1_match) {
        return standard_gs1_match[1];
    }

    const url_gs1_match = string.match(/-21-([A-Za-z0-9]{1,20})(?:-|%|$)/);

    if (url_gs1_match) {
        return url_gs1_match[1];
    }

    // ── Lenovo ──────────────────────────────────────────────────────────
    // Lenovo uses ASC MH10 / ISO-IEC 15418 Data Identifiers. The system serial
    // rides on the "1S" DI: <1S><10-char MTM><serial>, upper- or lowercase
    // (e.g. "1s21NTS96800PF6ALQSM" -> "PF6ALQSM"). Some labels (e.g. docks) only
    // carry the 4-char machine type: <1S><4-char MT><serial>
    // (e.g. "1S40AYZVW08P8S" -> "ZVW08P8S"). Serials are at least 7 chars, so a
    // 10-char MTM is only assumed when at least 17 chars follow the DI; shorter
    // values fall back to the 4-char machine type. The DI must start a field,
    // so we anchor on start-of-string or a separator, which also keeps us from
    // matching the "1S" inside the "11S"/"51S" (part-number) DIs.
    //
    // NOTE: the bare "S" DI (serial on its own) is intentionally NOT parsed
    // here. In a plain, non-delimited string an "S" prefix is indistinguishable
    // from a real serial that simply begins with "S" (e.g. "SABC1234567"), and
    // stripping it would silently corrupt valid input. "1S" is specific enough
    // (DI + fixed 10-char MTM) to be safe; a lone "S" is not.
    const field_start = '(?:^|[\\x1d\\x1e\\x04(,\\s])';
    const field_end = '(?=[\\x1d\\x1e\\x04(),\\s]|$)';

    const lenovo_mtm_serial_match = string.match(
        new RegExp(
            `${field_start}\\(?1S\\)?(?:[A-Za-z0-9]{10}([A-Za-z0-9]{7,20})|[A-Za-z0-9]{4}([A-Za-z0-9]{7,20}))${field_end}`,
            'i',
        ),
    );

    if (lenovo_mtm_serial_match) {
        return lenovo_mtm_serial_match[1] ?? lenovo_mtm_serial_match[2];
    }

    return null;
}

export function isNumeric(value) {
    if (value === null || value === undefined) {
        return false;
    }

    if (typeof value === 'string' && value.trim() === '') {
        return false;
    }

    const numeric_value = Number(value);

    return Number.isFinite(numeric_value);
}
